import { Box, Paper, Stack, Typography } from '@mui/material';
import moment from 'moment';
import React, { useContext } from 'react';
import { DashboardContext } from '../../../contexts/DashboardContext';
import OwnerCell from '../../atoms/tables/dashboards/rows/OwnerCell';
import SourceCell from '../../atoms/tables/dashboards/rows/SourceCell';
import StatusCell from '../../atoms/tables/dashboards/rows/StatusCell';
import { DashboardTitle } from '../../molecules/dashboard-header/DashboardTitle';
import CompanyMultiAction from '../../molecules/multi-action/CompanyMultiAction';

const CompanyHeader: React.FC<{}> = () => {
    const { dashboard, isPublicView } = useContext(DashboardContext);

    if (!dashboard)
        return (<></>);

    return (
        <Paper elevation={0} sx={{ p: 3, mb: 3, borderRadius: 1 }}>
            <Stack direction="row" justifyContent="space-between" alignItems="flex-start">
                <Box flex={1}>
                    <Stack alignItems="center" mb={1}>
                        <DashboardTitle readonly={isPublicView} noNav />
                    </Stack>
                    <Stack direction="row" spacing={4} mt={2} flexWrap="wrap">
                        <Stack direction="column" spacing={1} alignItems="flex-start">
                            <Typography fontSize={12} color="#6c757d" textTransform="uppercase" letterSpacing={0.5}>
                                {'Status'}
                            </Typography>
                            <StatusCell dashboard={dashboard} />
                        </Stack>
                        <Stack direction="column" spacing={1} alignItems="flex-start">
                            <Typography fontSize={12} color="#6c757d" textTransform="uppercase" letterSpacing={0.5}>
                                {'Owner'}
                            </Typography>
                            <OwnerCell dashboard={dashboard} expander />
                        </Stack>
                        <Stack direction="column" spacing={1} alignItems="flex-start">
                            <Typography fontSize={12} color="#6c757d" textTransform="uppercase" letterSpacing={0.5}>
                                {'Source'}
                            </Typography>
                            <SourceCell dashboard={dashboard} expander />
                        </Stack>
                        <Stack direction="column" spacing={1.25} alignItems="flex-start">
                            <Typography fontSize={12} color="#6c757d" textTransform="uppercase" letterSpacing={0.5}>
                                {'Last Activity'}
                            </Typography>
                            <Typography fontSize={15} fontWeight={700} color="#2c3e50">
                                {moment(dashboard.updatedAt).fromNow()}
                            </Typography>
                        </Stack>
                    </Stack>
                </Box>
                <CompanyMultiAction minimal />
            </Stack>
        </Paper>
    );
};

export default CompanyHeader;